import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import CompleteTenantRegistrationForm from './completeTenantRegistrationForm';
import IconComponent from '../../portal/iconComponent';
import LoginBanner from '../loginBanner';
import img from '../../../assets/images/png/ac-splash-full.jpg';

@inject('firstAdminRegisterationStore', 'configurationsStore', 'authStore') @observer
export default class CompleteTenantRegistration extends Component {

    handleResetPasswordClick = async (e) => {

        await this.props.authStore.login();
        window.localStorage.setItem('authStoreTenant', this.props.authStore.values.tenant);
        const { scaUrl } = this.props.configurationsStore;
        if (process.env.NODE_ENV === 'production') {
            //ONLY SAST
            window.location.href = window.location.origin + '/CxRestAPI/auth/#';
        } else {
            window.location.href = '/';
        }
    };

    componentWillMount() {

        this.props.firstAdminRegisterationStore.firstAdminExistence();
    }


    render() {

        if (this.props.firstAdminRegisterationStore.isFirstAdminExistence == null) {

            return null;
        }

        if (this.props.firstAdminRegisterationStore.isFirstAdminExistence.firstAdminExists === false) {
            return <Redirect to="/" />;
        }

        let formComponent = <CompleteTenantRegistrationForm handleResetPassword={this.handleResetPasswordClick} requireEula={this.props.requireEula} />;

        return (

            <div className="reset-password-mt-main-wrapper" data-cy="reset-password-screen">
                <div className="wrapper-left">
                    <div className="forms-wrapper">
                        <div className="logo-wrapper">
                            <IconComponent iconClassName="cx-logo-and-text-icon" />
                        </div>

                        {formComponent}
                    </div>
                </div>

                <div className="wrapper-right" style={{
                    backgroundPosition: 'left center',
                    backgroundSize: 'cover',
                    backgroundImage: `url(${img})`
                }}>
                    <LoginBanner />
                </div>
            </div>
        );
    }
}